// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__3fgzW","thumbnail":"Login_thumbnail__85Amv","message":"Login_message__1tvMP","loginPage":"Login_loginPage__tEEch"};